<template>
  <div class='page-start'>
    <mdb-container class="col-12 pb-3" fluid>
        <mdb-card class="mb-3 d-flex">
        <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">Quadrus Corporation IT Change Request #{{ this.ITCRid }}</h3>
        <mdb-card-body>
            <h4 class="font-weight-bold mb-3">ITCR Details</h4>
            <hr>
            <mdb-row>
                <mdb-col>
                    <mdb-input class="mb-3" v-model="ITCRid" label="ITCR Number" readOnly/>
                </mdb-col>
                <mdb-col>
                    <mdb-input class="mb-3" v-model="submitDate" label="Submit Date" readOnly/>
                </mdb-col>
                <mdb-col>
                    <mdb-input class="mb-3" v-model="submitter" label="Submitter" readOnly />
                </mdb-col>
                <mdb-col>
                    <mdb-input class="mb-3" v-model="itcrType" label="Type" readOnly />
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col>
                    <mdb-input type="textarea" :rows="4" outline class="mb-3 no-resize-textarea" v-model="changeDescription" label="Description" readOnly/>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col>
                    <mdb-input type="textarea" :rows="4" outline class="mb-3 no-resize-textarea" v-model="additionalNotes" label="Additional Notes" readOnly/>
                </mdb-col>
            </mdb-row>
            <mdb-row v-if="closeRequestReason">
                <mdb-col>
                    <mdb-input type="textarea" :rows="4" outline class="mb-3 no-resize-textarea" v-model="closeRequestReason" label="Close Reason" readOnly/>
                </mdb-col>
            </mdb-row>

            <!-- SIA -->
             <br>
             <h4 class="font-weight-bold mb-3">SIA Details</h4>
             <hr>
            <mdb-row>
                <mdb-col>
                    <mdb-input class="mb-3" v-model="siaReviewerName" label="SIA Reviewer" readOnly/>
                </mdb-col>
                <mdb-col>
                    <mdb-input class="mb-3" v-model="siaCompletionDate" label="SIA Review Date" readOnly/>
                </mdb-col>
                <mdb-col>
                    <mdb-input class="mb-3" v-model="siaDisposition" label="SIA Disposition" readOnly/>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col>
                    <mdb-input type="textarea" :rows="4" outline class="mb-3 no-resize-textarea" v-model="siaNotes" label="Security Impact" readOnly/>
                </mdb-col>
            </mdb-row>

            <!-- CCB -->
             <br>
             <h4 class="font-weight-bold mb-3">CCB Details</h4>
             <hr>
            <p v-if="cmApproved"><i>CCB Disposition was set by {{ this.CMforceApprove }}</i></p>
            <mdb-row>
                <mdb-col>
                    <mdb-input class="mb-3" v-model="ccbCompletionDate" label="CCB Completion Date" readOnly/>
                </mdb-col>
                <mdb-col>
                    <mdb-input class="mb-3" v-model="ccbDisposition" label="CCB Disposition" readOnly/>
                </mdb-col>
            </mdb-row>
            <mdb-row v-if="!cmApproved">
                <mdb-col>
                    <QDataTable id='memberTable' :rowData="this.members.rowData" :filterWords="this.members.filterWords" :headers="this.members.columns"
                    :class="{'hideTable': !isPopUpSetUp, 'fadeIn' : isPopUpSetUp}">
                    </QDataTable>
                    <div style="text-align: center !important" :class="{'hideSpinner': isPopUpSetUp}" class="p-4">
                      <span class="spinner-border spinner-border-xl" id="loadSpinner" role="status" aria-hidden="true"></span>
                    </div>
                </mdb-col>
            </mdb-row>

            <!-- Work-->
             <br>
             <h4 class="font-weight-bold mb-3">Work Details</h4>
             <hr>
            <mdb-row>
                <mdb-col>
                    <mdb-input class="mb-3" v-model="techAssignedToWork" label="User Assigned to Work" readOnly/>
                </mdb-col>
                <mdb-col>
                    <mdb-input class="mb-3" v-model="workCompletionDate" label="Work Completion Date" readOnly/>
                </mdb-col>
                <mdb-col>
                    <mdb-input class="mb-3" v-model="workDisposition" label="Work Disposition" readOnly/>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col>
                    <mdb-input type="textarea" :rows="4" outline class="mb-3 no-resize-textarea" v-model="workNotes" label="Work Notes" readOnly/>
                </mdb-col>
            </mdb-row>

            <!-- Verification -->
             <br>
             <h4 class="font-weight-bold mb-3">Verification Details</h4>
             <hr>
            <mdb-row>
                <mdb-col>
                    <mdb-input class="mb-3" v-model="testReviewer" label="Verification Reviewer" readOnly/>
                </mdb-col>
                <mdb-col>
                    <mdb-input class="mb-3" v-model="closeDate" label="Close Date" readOnly/>
                </mdb-col>
                <mdb-col>
                    <mdb-input class="mb-3" v-model="verificationPass" label="Verification Disposition" readOnly/>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col>
                    <mdb-input type="textarea" :rows="4" outline class="mb-3 no-resize-textarea" v-model="verificationNotes" label="Verification Notes" readOnly/>
                </mdb-col>
            </mdb-row>
        </mdb-card-body>
        </mdb-card>

    </mdb-container>
  </div>
</template>
<style>
.roundButton {
  border: none;
  font-size: 1.5em;
  width: 15%; 
  border-radius: 25%;
  padding: .1em;
}

.no-resize-textarea > textarea {
  height: 120px !important;
  max-height: 120px !important;
  overflow-y: auto !important;
  resize: none !important;
}
</style>
<script>
import { mdbCard, mdbCardBody, mdbContainer, mdbRow, mdbCol, mdbInput} from 'mdbvue';
import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
import { formatDate } from '@/assets/js/formatDate.js';
import QDataTable from '@/components/QDataTable.vue';

export default {
	name: 'View-QCRs',
	components: {
    mdbCard,
    mdbCardBody,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbInput,
    QDataTable
  },

  data() {
    return {  
        isPopUpSetUp: false,
        
        ITCRid: '',
        submitDate: '',
        submitter: '',
        changeDescription: '',
        additionalNotes: '',
        closeDate: '',
        stage: '',
        siaReviewerName: '',
        siaNotes: '',
        siaDisposition: '',
        techAssignedToWork: '',
        workDisposition: '',
        workNotes: '',
        testReviewer: '',
        verificationPass: '',
        verificationNotes: '',
        siaCompletionDate: '',
        workCompletionDate: '',
        ccbCompletionDate: '',
        closed: '',
        ccbDisposition: '',
        itcrType: '',
        closeRequestReason: '',
        cmApproved: false,
        ccbs: [],
        CMforceApprove: "",

        members:{
          columns: [  
            {
              colTitle: 'CCB Member Name',
              sortBy: 'name'
            },
            {
              colTitle: 'Approved/Disapproved IT CCB',
              sortBy: 'approved'
            },
            {
              colTitle: 'Comments',
              sortBy: 'comments'
            },
          ],
          rowData: [],
          filterWords: [
            'name',
            'approved',
            'comments'
          ]
        },
    }
  },
  
  methods: {
    //===========================================================================================
    //	Method Name	:	populateITCRData
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Gets the QCRs
    //===========================================================================================
    populateITCRData: async function() {
        let token = this.$store.getters.getToken;
        let query = "filters[id][$in][0]=" + this.ITCRid + "&populate[1]=ccbs";
        let response = await DatabaseLib.getRequest('strapiDatabase','itcrs',token,query,false);

        this.ITCRid = response.data.data[0].id;
        this.submitDate = formatDate(response.data.data[0].attributes.submitDate);
        this.submitter = response.data.data[0].attributes.submitter;
        this.changeDescription = response.data.data[0].attributes.changeDescription;
        this.additionalNotes = response.data.data[0].attributes.additionalNotes;
        this.stage = response.data.data[0].attributes.stage;
        this.siaReviewerName = response.data.data[0].attributes.siaReviewerName;
        this.siaCompletionDate = formatDate(response.data.data[0].attributes.siaCompletionDate);
        this.siaDisposition = response.data.data[0].attributes.siaDisposition;
        this.siaNotes = response.data.data[0].attributes.siaNotes;
        this.techAssignedToWork = response.data.data[0].attributes.techAssignedToWork;
        this.workCompletionDate = formatDate(response.data.data[0].attributes.workCompletionDate);
        this.workDisposition = response.data.data[0].attributes.workDisposition;
        this.workNotes = response.data.data[0].attributes.workNotes;
        this.testReviewer = response.data.data[0].attributes.testReviewer;
        this.verificationNotes = response.data.data[0].attributes.verificationNotes;
        this.verificationPass = response.data.data[0].attributes.verificationPass;
        this.ccbCompletionDate = formatDate(response.data.data[0].attributes.ccbCompletionDate);
        this.closed = response.data.data[0].attributes.closed;
        this.ccbDisposition = response.data.data[0].attributes.ccbDisposition;
        this.closeDate = formatDate(response.data.data[0].attributes.closeDate);
        this.closed = response.data.data[0].attributes.closed;
        this.itcrType = response.data.data[0].attributes.itcrType;
        this.closeRequestReason = response.data.data[0].attributes.closeRequestReason,
        this.ccbs = response.data.data[0].attributes.ccbs.data ? response.data.data[0].attributes.ccbs.data : [];
        this.CMforceApprove = response.data.data[0].attributes.forceDispositionCM;

        window.scroll({top: 0, behavior: 'smooth'});
    },

    getCCBMemeberData: async function(){
        this.isPopUpSetUp = false;
        this.members.rowData = [];

        for(let i = 0; i < this.ccbs.length; i = i + 1){
            this.members.rowData.push({
                name: this.ccbs[i].attributes.firstLastName, 
                approved: this.ccbs[i].attributes.approved ? "Approved" : "Disapproved",
                comments: this.ccbs[i].attributes.comments,
                completed: true
            });
        }

        if(this.ccbs.length == 0){
            //CM force approved
            this.cmApproved = true;
        }
        this.isPopUpSetUp = true;
      },

    bindProps: async function(){
        this.ITCRid = parseInt(this.$route.query.id);
        if(this.ITCRid){
          await this.populateITCRData();
          this.getCCBMemeberData();
        }
      }
   
  },

  mounted() {
    this.bindProps();
    window.scroll({top: 0, behavior: 'smooth'});
  }
}
</script>
